// VersionSync - Detects app version changes and triggers hard reload on navigation
import PageSync from './page-sync.js'
import { isDevEnv, isTestEnv } from './env.js'

const logEnabled = isDevEnv() || isTestEnv()

const VersionSync = {
  startupVersion: null,
  mustUpdate: false,

  log(...args) {
    if (logEnabled) console.log('[VersionSync]', ...args)
  },

  init() {
    const meta = document.querySelector('meta[name="app-version"]')
    this.startupVersion = meta ? meta.content : null
    this.log('Startup version:', this.startupVersion)

    if (!this.startupVersion) {
      this.log('No startup version, disabled')
      return
    }

    PageSync.register('/version', true, (action, resource) => {
      this.handleVersionUpdate(action, resource)
    })
    this.log('Subscribed to /version (persistent)')
  },

  handleVersionUpdate(action, resource) {
    if (action === 'version' && resource?.version) {
      const newVersion = resource.version
      this.log('Server:', newVersion, '| Startup:', this.startupVersion)
      if (newVersion !== this.startupVersion) {
        this.mustUpdate = true
        this.log('Version mismatch! Next nav triggers reload')
      }
    }
  },

  shouldHardReload() {
    return this.mustUpdate
  }
}

export default VersionSync
